import { SetStateAction } from 'react'

import { Observation, ProductType } from '../../types'
import { ObservationsParams } from '../Observations/types'
import {
  MenuContextualItems,
  OnActionCallback,
  TagDecorator,
} from './Views/types'

export type { Observation, ProductType }

export const TABULAR_MODE = 'tabular' as const
export const GRID_MODE = 'grid' as const

export type ObservationsBrowserMode = typeof TABULAR_MODE | typeof GRID_MODE

export type ObservationsBrowserHelpers = {
  openDetailsModal: () => void
  openAnnotationModal: () => void
}

export type ObservationsItemRenderer = (
  observation: Observation,
  helpers: ObservationsBrowserHelpers
) => React.ReactNode

export type ObservationsBrowserWidgets = (props: {
  params: ObservationsParams
  setParams: (params: ObservationsParams) => void
  viewMode: ObservationsBrowserMode
}) => React.ReactNode

export type ObservationsBrowserProps = {
  productType: ProductType
  productId: number
  trainingId?: number
  mode?: ObservationsBrowserMode
  defaultFilters?: ObservationsParams
  widgets?: ObservationsBrowserWidgets
  renderGridItem?: ObservationsItemRenderer
  renderTabularItem?: ObservationsItemRenderer
  lightweight?: boolean
  onModeChange?: (mode: ObservationsBrowserMode) => void
  // expose view props
  onItemClick?: OnActionCallback
  menuContextualItems?: MenuContextualItems
  tagDecorator?: TagDecorator
  setVisibleObservations?: (
    visibleObservations: SetStateAction<Observation[]>
  ) => void
  showUploadObservationsButton?: boolean
  uploadDisabled?: boolean
  imageData?: boolean
  dataset?: string[]
  viewingMode?: boolean
  order?: string[]
  direction?: 'asc' | 'desc'
  imagesCounter?: number
  onObservationsCreated?: (toAdd: number) => void
  updateSelectedObservations?: (observations: Observation[]) => void
  useWindowScroll?: boolean
  scrollContainerId?: string
  initialPageSize?: number
  resetFiltersOnDatasetChange?: boolean
  subHeaderContent?: React.ReactNode
}

export const isGridMode = (
  mode: ObservationsBrowserMode
): mode is typeof GRID_MODE => mode === GRID_MODE

export const isTabularMode = (
  mode: ObservationsBrowserMode
): mode is typeof TABULAR_MODE => mode === TABULAR_MODE
